<template>
  <div class="typeahead-field-edit basic-field-edit">
    <div class="typeahead-field-container form-group">
      <input
        ref="typeahead"
        v-model="inputValue"
        class="typeahead-field-input"
        name="product-select-typeahead"
        type="text"
        placeholder="Search"
        @focus="focus()"
      >
      <transition name="fade">
        <div
          v-if="showTypeahead"
          class="typeahead-field-options"
        >
          <div
            v-for="(option, index) in matchedOptions"
            :key="index"
            class="typeahead-field-option"
            @click="selectOption(option.nid)"
          >
            <div class="select-product-title">
              {{ option.title }}
            </div>
            <div class="select-product-subtitle">
              <small>SKU: {{ option.productsettings.sku }} || NID: {{ option.nid }} </small>
            </div>
            <!-- {{ option }} -->
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'typeahead-file-edit',
  props: {
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showTypeahead: false,
      inputValue: ''
    }
  },
  computed: {
    valueComputed: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    matchedOptions() {
      let escapedValue = this.inputValue
      escapedValue = escapedValue.replace(
        /[()\\|\[\]^$.?*+{}]/g,
        (match) => `\\${match}`
      ); /* eslint-disable-line */
      let a = new RegExp(`(?!^)${escapedValue}|${escapedValue}(?!$)`, 'i')
      return this.options.filter((option) => a.test(option.title))
    }
  },
  mounted() {
    this.inputValue = this.value
  },
  destroyed() {
    window.removeEventListener('click', this.hide)
  },
  methods: {
    selectOption(option) {
      this.valueComputed = option
      this.inputValue = ''
      this.showTypeahead = false
      this.$refs.typeahead.focus()
    },
    focus() {
      this.showTypeahead = true
      window.removeEventListener('click', this.hide)
      window.addEventListener('click', this.hide)
    },
    hide(e) {
      if (
        !(
          e.target.classList.contains('typeahead-field-options') ||
          e.target.classList.contains('typeahead-field-option') ||
          e.target.classList.contains('typeahead-field-input') ||
          e.target.classList.contains('select-product-title') ||
          e.target.classList.contains('select-product-subtitle')
        )
      ) {
        this.showTypeahead = false
        document.activeElement.blur()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-field-edit {
  margin-bottom: 1.5rem;
  .field-edit-label {
    font-size: 1.5em;
    margin-bottom: 0.75rem;
  }
}
.typeahead-field-edit {
  .typeahead-field-container {
    position: relative;

    .typeahead-field-input {
      //mimic bootstraps input?
      padding: 0.375rem 0.75rem;
      border: 1px solid;
      border-color: #ced4da;
      border-radius: 0.25rem;
      width: 100%;
    }

    .typeahead-field-options {
      position: absolute;
      background-color: white;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
      border-radius: 0px 0px 3px 3px;
      width: 100%;
      max-height: 300px;
      overflow-y: auto;
      overflow-x: auto;
      z-index: 999;

      .typeahead-field-option {
        padding: 1em;
        cursor: pointer;

        &:hover,
        &:focus {
          color: #fff;
          background-color: #87919c;
        }

        &:not(:last-child) {
          border-bottom: 1px solid;
          border-color: #ced4da;
        }

        .select-product-title,
        .select-product-subtitle {
          font-size: 0.8125rem;
          font-weight: 500;
          line-height: 1rem;
        }
      }
    }
  }
}
</style>
